import type { ProductListItem, ProductResponse } from '@printtat/shared';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';


export const productsApi = {
  async getProducts(category?: string): Promise<ProductListItem[]> {
    const qs = category ? `?category=${encodeURIComponent(category)}` : '';
    const res = await fetch(`${API_URL}/products${qs}`);
    if (!res.ok) throw new Error('Failed to fetch products');
    const data: ProductListItem[] = await res.json();
    return data;
  },

  async getProduct(idOrSlug: string): Promise<ProductResponse> {
    const res = await fetch(`${API_URL}/products/${encodeURIComponent(idOrSlug)}`);
    if (!res.ok) throw new Error('Failed to fetch product');
    const data: ProductResponse = await res.json();
    return data;
  },
};
